export const enum ONETRUST_CONSENT {
  essential = 'C0001',
  analytics = 'C0002',
  functional = 'C0003',
  personalized_advertising = 'C0004',
  marketing = 'C0005',
}
